import { useEffect, useRef } from 'react';
import useCurrentUser from 'containers/User/useCurrentUser.js';
import { isActive } from 'containers/User/UserProvider/userStorage.js';

/**
 * usePolling
 * @param {*} cb callback function to be called when polling; if omitted, just return whether polling should be done
 * @param {*} delay
 * @returns
 */
export function usePolling(cb, delay) {
  const { active } = useCurrentUser();
  const enabled = active && delay !== null && Boolean(cb);
  const pollHandle = useRef(null);

  function callback() {
    if (isActive()) { // Only is still visible and valid
      cb();
    }
  }

  function startPolling() {
    pollHandle.current = setInterval(callback, delay);
  }

  function stopPolling() {
    if (pollHandle.current) {
      clearInterval(pollHandle.current);
      pollHandle.current = null;
    }
  }

  useEffect(() => {
    stopPolling();
    if (enabled) {
      startPolling();
    }
    return stopPolling;
  }, [enabled, delay, cb]); // eslint-disable-line react-hooks/exhaustive-deps

  return enabled;
}

export default usePolling;
